module.exports = __webpack_public_path__ + "img/kalium-playstore.f24f2edf.svg";